import cx from "clsx"
import { Button, CountDown, Icon, Image, Skeleton, Space, Text, Title } from "components/common"
import { LOGIN_STORAGE_KEY, PROPPLUS_APP_LINK } from "constants"
import { useLazyGetQrCodeLoginQuery } from "features/shared/api"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { setIsLoggedIn } from "store/appSlice"
import { downloadFileFromLink } from "utils"
import { setStorageItem } from "utils/localStorage"
import theme from "utils/themeVars"
import styles from "../index.module.less"

const PropPlusAppInstall = ({ user: profile }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const appUser = useSelector(state => state.app.user?.info)
  const userId = profile?.uuid ?? profile?.user?.uuid ?? appUser?.uuid

  const [getQrCode, { data, isFetching }] = useLazyGetQrCodeLoginQuery()
  // const [getUser, { isFetching: isFetchingProfile }] = parentApi.useLazyGetUserDetailQuery()

  useEffect(() => {
    if (userId) {
      getQrCode({ userId })
    }
  }, [userId, getQrCode])

// Todo: will be needed that if we want to verify before going into login steps, its currently broken due to checks on userResp and user  in blocking criteria 
  // const handleContinue = () => {
  //   getUser()
  //     .unwrap()
  //     .then(profile => {
  //       if (!profile?.propPlusAppNotInstalled) {
  //         dispatch(setAppUser({ info: profile }))
  //         setStorageItem(LOGIN_STORAGE_KEY, "yes")
  //         setStorageItem(USER_STORAGE_KEY, profile)
  //         dispatch(setIsLoggedIn(true))
  //         notification.success({ message: t("PropPlus login verified") })
  //       } else {
  //         notification.info({ message: t("Please login to the PropPlus app to continue") })
  //       }
  //     })
  //     .catch(err => {
  //       notification.error({ message: err?.message || t("Something went wrong") })
  //     })
  // }

  return (
    <Space direction="vertical" size={16} className="text-center w-100">
      <Icon style={{ color: theme["primary-color"] }} icon="LogoIcon" size="40px" />
      <Title level={1}>{t("Login to PropPlus App")}</Title>
      <div className={styles.instructionContainer}>
        <Text type="secondary">{t("Please follow the steps below to log in to the PropPlus app:")}</Text>
        <Space direction="vertical" size={16} className="pb-16">
          <ol className={cx(styles.lists, "gray-900 mbe-0")}>
            <li>
              <Text>
                {t("Install and open the")}{" "}
                <span>
                  <Text
                    strong
                    type="primary"
                    className="pointer text-underline"
                    onClick={() => downloadFileFromLink({ url: PROPPLUS_APP_LINK, filename: "PropPlus" }, "url")}
                    block
                  >
                    {t("PropPlus app")}
                  </Text>
                </span>{" "}
                {t("on your device")}
              </Text>
            </li>
            <li>
              <Text>{t("Scan the QR code below within the app to complete login")}</Text>
            </li>
            <li>
              <Text>{t("Tap")} {<Text strong>{t("Continue")}</Text>} {t("once you have successfully signed in")}</Text>
            </li>
          </ol>
        </Space>
      </div>

      <Space direction="vertical" align="center" className="w-100 text-center p-5" size={24}>
        {isFetching ? (
          <Skeleton type="image" active style={{ height: 230, width: 230 }} />
        ) : (
          data?.qrCode && (
            <Image
              src={data.qrCode}
              preview={false}
              alt={t("QR Code")}
              height={200}
              width={200}
            />
          )
        )}
        {data?.exp && !isFetching && (
          <div style={{ textAlign: "center" }}>
            <Text type="secondary">
              {t("This QR code will expire after")}
              <CountDown
                value={Date.now() + data.exp * 1000}
                onFinish={() => {
                  userId && getQrCode({ userId })
                }}
                format="ss"
              />
              {t("seconds") + "."}
            </Text>
          </div>
        )}
      </Space>

      <Button
        type="link"
        size="large"
        text={t("Continue")}
        loading={isFetching}
        disabled={isFetching}
        onClick={() => { setStorageItem(LOGIN_STORAGE_KEY, "yes"); dispatch(setIsLoggedIn(true)) }}
      />
    </Space>
  )
}

export default PropPlusAppInstall
